export const MODAL_PADDING_PX = 16;
export const MODAL_PADDING_THICC_PX = 24;
export type ModalPaddingVariant = 'standard' | 'thicc';
